"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var lodash_1 = require("lodash");

var bluebird_1 = __importDefault(require("bluebird"));

var semver_1 = __importDefault(require("semver"));

var PolymathError_1 = require("./PolymathError");

var types_1 = require("./types");

var constants_1 = require("./utils/constants");
/**
 * Class that wraps the polymathnetwork/contract-wrappers library to add utility functions
 */


var PolymathBase =
/*#__PURE__*/
function (_contract_wrappers_1$) {
  _inherits(PolymathBase, _contract_wrappers_1$);

  function PolymathBase() {
    var _this;

    _classCallCheck(this, PolymathBase);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PolymathBase).apply(this, arguments));
    /**
     * Fetch the address of a specified Module Factory
     */

    _this.getModuleFactoryAddress = function (_ref) {
      var moduleName = _ref.moduleName,
          tokenAddress = _ref.tokenAddress;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _moduleTypes,
            _this2 = this;

        var moduleTypes, availableModules, address, latestVersion;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                moduleTypes = (_moduleTypes = {}, _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.CappedSTO, contract_wrappers_1.ModuleType.STO), _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.UsdTieredSTO, contract_wrappers_1.ModuleType.STO), _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.GeneralTransferManager, contract_wrappers_1.ModuleType.TransferManager), _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.CountTransferManager, contract_wrappers_1.ModuleType.TransferManager), _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.PercentageTransferManager, contract_wrappers_1.ModuleType.TransferManager), _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.ManualApprovalTransferManager, contract_wrappers_1.ModuleType.TransferManager), _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.BlacklistTransferManager, contract_wrappers_1.ModuleType.TransferManager), _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.LockUpTransferManager, contract_wrappers_1.ModuleType.TransferManager), _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.VolumeRestrictionTM, contract_wrappers_1.ModuleType.TransferManager), _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.RestrictedPartialSaleTM, contract_wrappers_1.ModuleType.TransferManager), _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.ERC20DividendCheckpoint, contract_wrappers_1.ModuleType.Dividends), _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.EtherDividendCheckpoint, contract_wrappers_1.ModuleType.Dividends), _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.GeneralPermissionManager, contract_wrappers_1.ModuleType.PermissionManager), _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.VestingEscrowWallet, contract_wrappers_1.ModuleType.Wallet), _defineProperty(_moduleTypes, contract_wrappers_1.ModuleName.AdvancedPLCRVotingCheckpoint, contract_wrappers_1.ModuleType.Dividends), _moduleTypes);
                _context2.next = 3;
                return this.moduleRegistry.getModulesByTypeAndToken({
                  securityToken: tokenAddress,
                  moduleType: moduleTypes[moduleName]
                });

              case 3:
                availableModules = _context2.sent;
                address = null;
                latestVersion = '0.0.0'; // Get latest version of the module factory

                _context2.next = 8;
                return bluebird_1.default.each(availableModules, function (moduleAddress) {
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee() {
                    var moduleFactory, name, version;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return this.moduleFactory.getModuleFactory(moduleAddress);

                          case 2:
                            moduleFactory = _context.sent;
                            _context.next = 5;
                            return moduleFactory.name();

                          case 5:
                            name = _context.sent;

                            if (!(moduleName.localeCompare(name) === 0)) {
                              _context.next = 11;
                              break;
                            }

                            _context.next = 9;
                            return moduleFactory.version();

                          case 9:
                            version = _context.sent;

                            if (semver_1.default.gte(version, latestVersion)) {
                              latestVersion = version;
                              address = moduleAddress;
                            }

                          case 11:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));
                });

              case 8:
                if (!(address !== null)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", address);

              case 10:
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.InexistentModule,
                  message: "Module factory for \"".concat(moduleName, "\" was not found.")
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    /**
     * Fetch a Module's Treasury Wallet
     */


    _this.getTreasuryWallet = function (_ref2) {
      var module = _ref2.module;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var stAddress, token, defaultWallet, wallet;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return module.securityToken();

              case 2:
                stAddress = _context3.sent;
                _context3.next = 5;
                return this.tokenFactory.getSecurityTokenInstanceFromAddress(stAddress);

              case 5:
                token = _context3.sent;
                _context3.next = 8;
                return token.getTreasuryWallet();

              case 8:
                defaultWallet = _context3.sent;

                if (!contract_wrappers_1.isCappedSTO(module)) {
                  _context3.next = 12;
                  break;
                }

                if (!contract_wrappers_1.isCappedSTO_3_0_0(module)) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt("return", defaultWallet);

              case 12:
                if (!contract_wrappers_1.isUSDTieredSTO(module)) {
                  _context3.next = 18;
                  break;
                }

                if (!contract_wrappers_1.isUSDTieredSTO_3_0_0(module)) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 16;
                return module.treasuryWallet();

              case 16:
                wallet = _context3.sent;
                return _context3.abrupt("return", wallet === constants_1.ZERO_ADDRESS ? defaultWallet : wallet);

              case 18:
                if (!contract_wrappers_1.isGeneralPermissionManager(module)) {
                  _context3.next = 20;
                  break;
                }

                return _context3.abrupt("return", defaultWallet);

              case 20:
                if (!contract_wrappers_1.isGeneralTransferManager(module)) {
                  _context3.next = 22;
                  break;
                }

                return _context3.abrupt("return", defaultWallet);

              case 22:
                if (!contract_wrappers_1.isBlacklistTransferManager(module)) {
                  _context3.next = 24;
                  break;
                }

                return _context3.abrupt("return", defaultWallet);

              case 24:
                if (!contract_wrappers_1.isLockUpTransferManager(module)) {
                  _context3.next = 26;
                  break;
                }

                return _context3.abrupt("return", defaultWallet);

              case 26:
                if (!contract_wrappers_1.isCountTransferManager(module)) {
                  _context3.next = 28;
                  break;
                }

                return _context3.abrupt("return", defaultWallet);

              case 28:
                if (!contract_wrappers_1.isManualApprovalTransferManager(module)) {
                  _context3.next = 30;
                  break;
                }

                return _context3.abrupt("return", defaultWallet);

              case 30:
                if (!contract_wrappers_1.isPercentageTransferManager(module)) {
                  _context3.next = 32;
                  break;
                }

                return _context3.abrupt("return", defaultWallet);

              case 32:
                if (!contract_wrappers_1.isVolumeRestrictionTransferManager(module)) {
                  _context3.next = 34;
                  break;
                }

                return _context3.abrupt("return", defaultWallet);

              case 34:
                if (!contract_wrappers_1.isRestrictedPartialSaleTransferManager(module)) {
                  _context3.next = 36;
                  break;
                }

                return _context3.abrupt("return", defaultWallet);

              case 36:
                return _context3.abrupt("return", module.getTreasuryWallet());

              case 37:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };
    /**
     * Fetch addresses of all Modules of a certain type attached to a Security Token
     */


    _this.getModuleAddressesByName = function (_ref3, opts) {
      var symbol = _ref3.symbol,
          moduleName = _ref3.moduleName;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this3 = this;

        var tokenFactory, securityToken, moduleAddresses, filteredModuleAddresses;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                tokenFactory = this.tokenFactory;
                _context5.next = 3;
                return tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 3:
                securityToken = _context5.sent;
                _context5.next = 6;
                return securityToken.getModulesByName({
                  moduleName: moduleName
                });

              case 6:
                moduleAddresses = _context5.sent;

                if (!(opts && opts.unarchived)) {
                  _context5.next = 13;
                  break;
                }

                _context5.next = 10;
                return bluebird_1.default.filter(moduleAddresses, function (moduleAddress) {
                  return __awaiter(_this3, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee4() {
                    var _ref4, archived;

                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return securityToken.getModule({
                              moduleAddress: moduleAddress
                            });

                          case 2:
                            _ref4 = _context4.sent;
                            archived = _ref4.archived;
                            return _context4.abrupt("return", !archived);

                          case 5:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));
                });

              case 10:
                filteredModuleAddresses = _context5.sent;
                _context5.next = 14;
                break;

              case 13:
                filteredModuleAddresses = moduleAddresses;

              case 14:
                return _context5.abrupt("return", filteredModuleAddresses);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    };
    /**
     * Fetch all Modules of a certain type attached to a Security Token
     */


    _this.getAttachedModules = function (_ref5, opts) {
      var symbol = _ref5.symbol,
          moduleName = _ref5.moduleName;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var moduleFactory, moduleAddresses, getModuleInstance, wrappedModules;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                moduleFactory = this.moduleFactory;
                _context6.next = 3;
                return this.getModuleAddressesByName({
                  moduleName: moduleName,
                  symbol: symbol
                }, opts);

              case 3:
                moduleAddresses = _context6.sent;
                getModuleInstance = moduleFactory.getModuleInstance; // This has to be done this way because of typescript limitations

                _context6.t0 = moduleName;
                _context6.next = _context6.t0 === contract_wrappers_1.ModuleName.GeneralPermissionManager ? 8 : _context6.t0 === contract_wrappers_1.ModuleName.CountTransferManager ? 12 : _context6.t0 === contract_wrappers_1.ModuleName.GeneralTransferManager ? 16 : _context6.t0 === contract_wrappers_1.ModuleName.ManualApprovalTransferManager ? 20 : _context6.t0 === contract_wrappers_1.ModuleName.PercentageTransferManager ? 24 : _context6.t0 === contract_wrappers_1.ModuleName.VolumeRestrictionTM ? 28 : _context6.t0 === contract_wrappers_1.ModuleName.BlacklistTransferManager ? 32 : _context6.t0 === contract_wrappers_1.ModuleName.LockUpTransferManager ? 36 : _context6.t0 === contract_wrappers_1.ModuleName.RestrictedPartialSaleTM ? 40 : _context6.t0 === contract_wrappers_1.ModuleName.CappedSTO ? 44 : _context6.t0 === contract_wrappers_1.ModuleName.UsdTieredSTO ? 48 : _context6.t0 === contract_wrappers_1.ModuleName.ERC20DividendCheckpoint ? 52 : _context6.t0 === contract_wrappers_1.ModuleName.EtherDividendCheckpoint ? 56 : _context6.t0 === contract_wrappers_1.ModuleName.VestingEscrowWallet ? 60 : 64;
                break;

              case 8:
                _context6.next = 10;
                return bluebird_1.default.map(moduleAddresses, function (moduleAddress) {
                  return getModuleInstance({
                    address: moduleAddress,
                    name: moduleName
                  });
                });

              case 10:
                wrappedModules = _context6.sent;
                return _context6.abrupt("return", wrappedModules);

              case 12:
                _context6.next = 14;
                return bluebird_1.default.map(moduleAddresses, function (moduleAddress) {
                  return getModuleInstance({
                    address: moduleAddress,
                    name: moduleName
                  });
                });

              case 14:
                wrappedModules = _context6.sent;
                return _context6.abrupt("return", wrappedModules);

              case 16:
                _context6.next = 18;
                return bluebird_1.default.map(moduleAddresses, function (moduleAddress) {
                  return getModuleInstance({
                    address: moduleAddress,
                    name: moduleName
                  });
                });

              case 18:
                wrappedModules = _context6.sent;
                return _context6.abrupt("return", wrappedModules);

              case 20:
                _context6.next = 22;
                return bluebird_1.default.map(moduleAddresses, function (moduleAddress) {
                  return getModuleInstance({
                    address: moduleAddress,
                    name: moduleName
                  });
                });

              case 22:
                wrappedModules = _context6.sent;
                return _context6.abrupt("return", wrappedModules);

              case 24:
                _context6.next = 26;
                return bluebird_1.default.map(moduleAddresses, function (moduleAddress) {
                  return getModuleInstance({
                    address: moduleAddress,
                    name: moduleName
                  });
                });

              case 26:
                wrappedModules = _context6.sent;
                return _context6.abrupt("return", wrappedModules);

              case 28:
                _context6.next = 30;
                return bluebird_1.default.map(moduleAddresses, function (moduleAddress) {
                  return getModuleInstance({
                    address: moduleAddress,
                    name: moduleName
                  });
                });

              case 30:
                wrappedModules = _context6.sent;
                return _context6.abrupt("return", wrappedModules);

              case 32:
                _context6.next = 34;
                return bluebird_1.default.map(moduleAddresses, function (moduleAddress) {
                  return getModuleInstance({
                    address: moduleAddress,
                    name: moduleName
                  });
                });

              case 34:
                wrappedModules = _context6.sent;
                return _context6.abrupt("return", wrappedModules);

              case 36:
                _context6.next = 38;
                return bluebird_1.default.map(moduleAddresses, function (moduleAddress) {
                  return getModuleInstance({
                    address: moduleAddress,
                    name: moduleName
                  });
                });

              case 38:
                wrappedModules = _context6.sent;
                return _context6.abrupt("return", wrappedModules);

              case 40:
                _context6.next = 42;
                return bluebird_1.default.map(moduleAddresses, function (moduleAddress) {
                  return getModuleInstance({
                    address: moduleAddress,
                    name: moduleName
                  });
                });

              case 42:
                wrappedModules = _context6.sent;
                return _context6.abrupt("return", wrappedModules);

              case 44:
                _context6.next = 46;
                return bluebird_1.default.map(moduleAddresses, function (moduleAddress) {
                  return getModuleInstance({
                    address: moduleAddress,
                    name: moduleName
                  });
                });

              case 46:
                wrappedModules = _context6.sent;
                return _context6.abrupt("return", wrappedModules);

              case 48:
                _context6.next = 50;
                return bluebird_1.default.map(moduleAddresses, function (moduleAddress) {
                  return getModuleInstance({
                    address: moduleAddress,
                    name: moduleName
                  });
                });

              case 50:
                wrappedModules = _context6.sent;
                return _context6.abrupt("return", wrappedModules);

              case 52:
                _context6.next = 54;
                return bluebird_1.default.map(moduleAddresses, function (moduleAddress) {
                  return getModuleInstance({
                    address: moduleAddress,
                    name: moduleName
                  });
                });

              case 54:
                wrappedModules = _context6.sent;
                return _context6.abrupt("return", wrappedModules);

              case 56:
                _context6.next = 58;
                return bluebird_1.default.map(moduleAddresses, function (moduleAddress) {
                  return getModuleInstance({
                    address: moduleAddress,
                    name: moduleName
                  });
                });

              case 58:
                wrappedModules = _context6.sent;
                return _context6.abrupt("return", wrappedModules);

              case 60:
                _context6.next = 62;
                return bluebird_1.default.map(moduleAddresses, function (moduleAddress) {
                  return getModuleInstance({
                    address: moduleAddress,
                    name: moduleName
                  });
                });

              case 62:
                wrappedModules = _context6.sent;
                return _context6.abrupt("return", wrappedModules);

              case 64:
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.InexistentModule,
                  message: "There is no module with name ".concat(moduleName)
                });

              case 65:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    };
    /**
     * Get data associated to a Checkpoint
     */


    _this.getCheckpoint = function (_ref6) {
      var checkpointId = _ref6.checkpointId,
          securityToken = _ref6.securityToken;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var checkpointTimes;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return securityToken.getCheckpointTimes();

              case 2:
                checkpointTimes = _context7.sent;
                return _context7.abrupt("return", this.getCheckpointData({
                  checkpointId: checkpointId,
                  time: checkpointTimes[checkpointId - 1],
                  securityToken: securityToken
                }));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    };
    /**
     * Get all Checkpoints of a Security Token
     */


    _this.getCheckpoints = function (_ref7) {
      var securityToken = _ref7.securityToken;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var _this4 = this;

        var checkpointTimes, checkpoints;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return securityToken.getCheckpointTimes();

              case 2:
                checkpointTimes = _context8.sent;
                _context8.next = 5;
                return bluebird_1.default.map(checkpointTimes, function (time, index) {
                  return _this4.getCheckpointData({
                    checkpointId: index + 1,
                    time: time,
                    securityToken: securityToken
                  });
                });

              case 5:
                checkpoints = _context8.sent;
                return _context8.abrupt("return", checkpoints.sort(function (a, b) {
                  return a.index - b.index;
                }));

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
    };
    /**
     * @hidden
     */


    _this.getCheckpointData = function (_ref8) {
      var checkpointId = _ref8.checkpointId,
          time = _ref8.time,
          securityToken = _ref8.securityToken;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var _this5 = this;

        var totalSupply, tokenholderAddresses, tokenholderBalances;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return securityToken.totalSupplyAt({
                  checkpointId: checkpointId
                });

              case 2:
                totalSupply = _context10.sent;
                _context10.next = 5;
                return securityToken.getInvestorsAt({
                  checkpointId: checkpointId
                });

              case 5:
                tokenholderAddresses = _context10.sent;
                _context10.next = 8;
                return bluebird_1.default.map(tokenholderAddresses, function (tokenholderAddress) {
                  return __awaiter(_this5, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee9() {
                    var balance;
                    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            _context9.next = 2;
                            return securityToken.balanceOfAt({
                              checkpointId: checkpointId,
                              investor: tokenholderAddress
                            });

                          case 2:
                            balance = _context9.sent;
                            return _context9.abrupt("return", {
                              balance: balance,
                              address: tokenholderAddress
                            });

                          case 4:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9);
                  }));
                });

              case 8:
                tokenholderBalances = _context10.sent;
                return _context10.abrupt("return", {
                  index: checkpointId,
                  totalSupply: totalSupply,
                  tokenholderBalances: tokenholderBalances,
                  createdAt: time
                });

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));
    };
    /**
     * Get data associated to a specific Dividend Distribution
     */


    _this.getDividend = function (_ref9) {
      var dividendIndex = _ref9.dividendIndex,
          dividendsModule = _ref9.dividendsModule;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var tokenAddress, token, symbol, dividend, dividendProgressList, tokenholders, checkpointId, created, maturity, expiry, amount, claimedAmount, totalSupply, reclaimed, totalWithheld, totalWithheldWithdrawn, name;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return dividendsModule.dividendTokens({
                  dividendIndex: dividendIndex
                });

              case 2:
                tokenAddress = _context11.sent;
                _context11.next = 5;
                return this.tokenFactory.getERC20TokenInstanceFromAddress(tokenAddress);

              case 5:
                token = _context11.sent;
                _context11.next = 8;
                return token.symbol();

              case 8:
                symbol = _context11.sent;
                _context11.next = 11;
                return dividendsModule.dividends({
                  dividendIndex: dividendIndex
                });

              case 11:
                dividend = _context11.sent;
                _context11.next = 14;
                return dividendsModule.getDividendProgress({
                  dividendIndex: dividendIndex
                });

              case 14:
                dividendProgressList = _context11.sent;
                tokenholders = dividendProgressList.map(function (_ref10) {
                  var investor = _ref10.investor,
                      claimed = _ref10.claimed,
                      excluded = _ref10.excluded,
                      withheld = _ref10.withheld,
                      amount = _ref10.amount,
                      balance = _ref10.balance;
                  return {
                    address: investor,
                    paymentReceived: claimed,
                    excluded: excluded,
                    withheldTax: withheld,
                    amountReceived: amount,
                    balance: balance
                  };
                });
                checkpointId = dividend.checkpointId, created = dividend.created, maturity = dividend.maturity, expiry = dividend.expiry, amount = dividend.amount, claimedAmount = dividend.claimedAmount, totalSupply = dividend.totalSupply, reclaimed = dividend.reclaimed, totalWithheld = dividend.totalWithheld, totalWithheldWithdrawn = dividend.totalWithheldWithdrawn, name = dividend.name;
                return _context11.abrupt("return", {
                  index: dividendIndex,
                  checkpointId: checkpointId,
                  created: created,
                  maturity: maturity,
                  expiry: expiry,
                  amount: amount,
                  claimedAmount: claimedAmount,
                  totalSupply: totalSupply,
                  reclaimed: reclaimed,
                  totalWithheld: totalWithheld,
                  totalWithheldWithdrawn: totalWithheldWithdrawn,
                  name: name,
                  currency: symbol,
                  tokenholders: tokenholders
                });

              case 18:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    };
    /**
     * Fetch list of all Dividends at a certain Checkpoint
     */


    _this.getDividendsByCheckpoint = function (_ref11) {
      var checkpointId = _ref11.checkpointId,
          dividendsModule = _ref11.dividendsModule;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var _this6 = this;

        var dividendIndexes, dividends;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return dividendsModule.getDividendIndex({
                  checkpointId: checkpointId
                });

              case 2:
                dividendIndexes = _context12.sent;
                _context12.next = 5;
                return bluebird_1.default.map(dividendIndexes, function (dividendIndex) {
                  return _this6.getDividend({
                    dividendIndex: dividendIndex,
                    dividendsModule: dividendsModule
                  });
                });

              case 5:
                dividends = _context12.sent;
                return _context12.abrupt("return", dividends.sort(function (a, b) {
                  return a.index - b.index;
                }));

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));
    };

    _this.getDividends = function (_ref12) {
      var dividendsModule = _ref12.dividendsModule;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        var _this7 = this;

        var stAddress, securityToken, currentCheckpointIndex, checkpointIndexes, dividends;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return dividendsModule.securityToken();

              case 2:
                stAddress = _context13.sent;
                _context13.next = 5;
                return this.tokenFactory.getSecurityTokenInstanceFromAddress(stAddress);

              case 5:
                securityToken = _context13.sent;
                _context13.next = 8;
                return securityToken.currentCheckpointId();

              case 8:
                currentCheckpointIndex = _context13.sent;
                checkpointIndexes = lodash_1.range(1, currentCheckpointIndex.toNumber() + 1);
                _context13.next = 12;
                return bluebird_1.default.map(checkpointIndexes, function (checkpointId) {
                  return _this7.getDividendsByCheckpoint({
                    checkpointId: checkpointId,
                    dividendsModule: dividendsModule
                  });
                });

              case 12:
                dividends = _context13.sent;
                return _context13.abrupt("return", lodash_1.flatten(dividends).sort(function (a, b) {
                  return a.index - b.index;
                }));

              case 14:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    };
    /**
     * Auxiliary function to fetch all dividend distributions
     */


    _this.getAllDividends = function (_ref13) {
      var securityTokenSymbol = _ref13.securityTokenSymbol,
          checkpointId = _ref13.checkpointId;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        var erc20Module, dividends;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.ERC20DividendCheckpoint,
                  symbol: securityTokenSymbol
                }, {
                  unarchived: true
                });

              case 2:
                erc20Module = _context14.sent[0];

                if (erc20Module) {
                  _context14.next = 5;
                  break;
                }

                return _context14.abrupt("return", []);

              case 5:
                _context14.next = 7;
                return checkpointId !== undefined ? this.getDividendsByCheckpoint({
                  checkpointId: checkpointId,
                  dividendsModule: erc20Module
                }) : this.getDividends({
                  dividendsModule: erc20Module
                });

              case 7:
                dividends = _context14.sent;
                return _context14.abrupt("return", dividends);

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    };

    _this.roleToPermission = function (_ref14) {
      var role = _ref14.role;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        var moduleName, permission;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(role === types_1.SecurityTokenRole.TokenholdersAdministrator)) {
                  _context15.next = 5;
                  break;
                }

                moduleName = contract_wrappers_1.ModuleName.GeneralTransferManager;
                permission = contract_wrappers_1.Perm.Admin;
                _context15.next = 26;
                break;

              case 5:
                if (!(role === types_1.SecurityTokenRole.PermissionsAdministrator)) {
                  _context15.next = 10;
                  break;
                }

                moduleName = contract_wrappers_1.ModuleName.GeneralPermissionManager;
                permission = contract_wrappers_1.Perm.Admin;
                _context15.next = 26;
                break;

              case 10:
                if (!(role === types_1.SecurityTokenRole.TokenholderCountRestrictionsAdministrator)) {
                  _context15.next = 15;
                  break;
                }

                moduleName = contract_wrappers_1.ModuleName.CountTransferManager;
                permission = contract_wrappers_1.Perm.Admin;
                _context15.next = 26;
                break;

              case 15:
                if (!(role === types_1.SecurityTokenRole.PercentageOwnershipRestrictionsAdministrator)) {
                  _context15.next = 20;
                  break;
                }

                moduleName = contract_wrappers_1.ModuleName.PercentageTransferManager;
                permission = contract_wrappers_1.Perm.Admin;
                _context15.next = 26;
                break;

              case 20:
                if (![types_1.SecurityTokenRole.DividendsAdministrator, types_1.SecurityTokenRole.DividendsOperator].includes(role)) {
                  _context15.next = 25;
                  break;
                }

                moduleName = contract_wrappers_1.ModuleName.ERC20DividendCheckpoint;
                permission = role === types_1.SecurityTokenRole.DividendsAdministrator ? contract_wrappers_1.Perm.Admin : contract_wrappers_1.Perm.Operator;
                _context15.next = 26;
                break;

              case 25:
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FatalError,
                  message: "Role ".concat(role, " not supported")
                });

              case 26:
                return _context15.abrupt("return", {
                  permission: permission,
                  moduleName: moduleName
                });

              case 27:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));
    };

    return _this;
  }

  return PolymathBase;
}(contract_wrappers_1.PolymathAPI);

exports.PolymathBase = PolymathBase;